import { useEffect, useState } from "react";
import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";
import { Delete } from "@mui/icons-material";
import useService from "../../../../hooks/useService";
import ReferralFrom from "./ReferralFrom";
import ReferralTo from "./ReferralTo";
import ProviderTypes from "./ProviderType";
import ReferredDate from "./ReferredDate";
import Source from "./Source";
import Status from "./Status";
import { STRINGS } from "../utils/Strings";

export default function AddReferralItem({ onDelete, onChange }) {
  const providerRepository = useService("repositories/provider-repository");
  const fieldOptionRepository = useService(
    "repositories/field-option-repository"
  );
  const providerTypesRepository = useService(
    "repositories/provider-type-repository"
  );

  const [referralTo, setReferralTo] = useState(null);

  const [defaultStatus, setDefaultStatus] = useState(null);

  const parseData = (items) =>
    items.map((item) => ({
      id: item.key,
      key: item.key,
      label: item.label,
  }));

  useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await fieldOptionRepository.query({
            content_type: "providerreferral",
            field_name: "status",
          });
          const mapped = parseData(response);
          const status = mapped.find((item)=>item.label.toUpperCase() === STRINGS.DEFAULT_STATUS);
          setDefaultStatus(status);
          onChange("status", status);
        } catch (error) {
          throw error;
        }
      };
  
      fetchData();

      
  }, [fieldOptionRepository]);

  return (
    <div className="bg-white p-2 flex flex-row justify-center gap-4 w-full shadow-md">
      <div className="w-48">
        <ReferralFrom repository={providerRepository} onChange={onChange} />
      </div>
      <div className="w-48">
        <ReferralTo
          repository={providerRepository}
          onChange={(field, value) => {
            onChange(field, value?.id ?? null);
            if (field === "referralTo") {
              setReferralTo(value);
            }
          }}
        />
      </div>
      <div className="w-48">
        <ProviderTypes
          key={referralTo?.id}
          repository={providerTypesRepository}
          referralTo={referralTo}
          onChange={onChange}
          providerTypes={
            referralTo === null ? [] : referralTo?.providerTypes || []
          }
        />
      </div>
      <div className="w-48">
        <ReferredDate onChange={onChange} />
      </div>
      <div className="w-48">
        <Source repository={fieldOptionRepository} onChange={onChange} />
      </div>
      <div className="w-48">
        <Status initValue = {defaultStatus} repository={fieldOptionRepository} onChange={onChange} />
      </div>
      <div>
        <CustomIconButton
          classes="p-2"
          iconVisible={true}
          CustomIcon={<Delete className="text-red-500" />}
          handleOnClick={onDelete}
        />
      </div>
    </div>
  );
}
